import { FC } from 'react';
import { Box, Modal, Typography, CircularProgress } from '@mui/material';

interface IProps {
	open: boolean;
	message?: string;
}
const LoadingModal: FC<IProps> = ({ open, message = 'Loading...' }) => (
	<Modal open={open} aria-labelledby='loading-modal-title' aria-describedby='helper-modal-modal-description'>
		<Box
			sx={(theme) => ({
				outline: 'none',
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				color: theme.palette.common.white,
				[theme.breakpoints.down('md')]: {
					width: '90%',
				},
			})}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					'& > *': {
						my: 2,
					},
				}}
			>
				<CircularProgress color='inherit' size={200} />
				<Typography variant='h4' color='inherit' sx={{ textAlign: 'center' }}>
					{message}
				</Typography>
			</Box>
		</Box>
	</Modal>
);

export default LoadingModal;
